import desktopImg from "../../../src/assets/img/landing/landing-page.screenshot-DESKTOP-market.png";
import mobileImg1 from "../../../src/assets/img/landing/landing-page.screenshot-MOBILE-home-2.png";
import mobileImg2 from "../../../src/assets/img/landing/landing-page.screenshot-MOBILE-market.png";
import { Card } from "@heroui/react";

type Feature = {
  title: string;
  text: string;
};

const features: Feature[] = [
  {
    title: "Long or short",
    text: "The more right you are, the more you win",
  },
  {
    title: "4x leverage",
    text: "Quadruple the action. Liquidation risk is real",
  },
  {
    title: "The Mash Index",
    text: "An entirely new way to sweat sports",
  },
  {
    title: "Mash Liquidity Provider",
    text: "Building the deepest onchain liquidity in sports betting",
  },
];

function FeatureCard({ title, text }: Feature) {
  return (
    <Card className="rounded-lg p-6 shadow-none">
      <h3 className="font-semibold mb-2 text-center text-[16px]">{title}</h3>
      <p className="text-[12px] text-center">{text}</p>
    </Card>
  );
}

// common classes
const headingClass = "text-[2.7rem] sm:text-5xl md:text-[6rem] font-bold";
const featureColumnClass = "hidden xl:flex flex-col gap-4 md:py-32 2xl:py-48";
const gradientClass =
  "bowlby-one-sc bg-clip-text text-transparent bg-[length:200%_100%] animate-[gradient_15s_linear_infinite]";
const gradientStyle = {
  backgroundImage: "linear-gradient(to right, #E14796, #48B9F8,  #F16E80)",
};

// column of cards
function FeatureColumn({ items }: { items: Feature[] }) {
  return (
    <div className={featureColumnClass}>
      {items.map((f, i) => (
        <FeatureCard key={i} {...f} />
      ))}
    </div>
  );
}

export default function Overview() {
  return (
    <div className="container mx-auto px-6 xl:p-0  text-[rgb(204,204,204)] my-[6rem] sm:my-28">
      <div className="flex flex-col items-center text-center leading-snug">
        {/* Title */}
        <div className="flex flex-col mb-6">
          <span className="px-3 py-1 rounded-md text-[1.6rem] sm:text-[2rem] md:text-[2.4rem]">
            The Flagship Application
          </span>
          <span className={headingClass}>sports perps</span>
          <span
            className={`${headingClass} ${gradientClass}`}
            style={gradientStyle}
          >
            all the upside
          </span>
        </div>

        {/* Image and features */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-[250px_1fr_250px] gap-4 w-full">
          {/* Left column */}
          <FeatureColumn items={features.slice(0, 2)} />

          {/* Center column */}
          <div className="col-span-1 md:col-span-2 xl:col-span-1 flex justify-center items-start relative">
            <div className="w-full flex justify-center items-center relative">
              {/* Mobile Images */}
              <div className="block md:hidden relative w-[70%] max-w-[300px] h-[500px]">
                <img
                  src={mobileImg1}
                  alt="landing preview mobile"
                  className="absolute -left-16 w-full h-auto"
                />
                <img
                  src={mobileImg2}
                  alt="landing preview mobile"
                  className="absolute -bottom-12 left-12 w-full h-auto"
                />
              </div>

              {/* Desktop Image */}
              <img
                src={desktopImg}
                alt="landing preview desktop"
                className="hidden md:block w-full h-auto object-contain"
              />

              <img
                src={mobileImg1}
                alt="mobile preview bottom right"
                className="hidden md:block absolute -bottom-16 right-12 w-[24vw] lg:w-[26vw] xl:w-[18vw] h-auto"
              />
            </div>
          </div>

          {/* Right column */}
          <FeatureColumn items={features.slice(2, 4)} />
        </div>

        {/* Features for mobile/tablet */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:hidden gap-4 md:pt-20">
          {features.map((f, index) => (
            <FeatureCard key={index} {...f} />
          ))}
        </div>
      </div>
    </div>
  );
}
